import { render, staticRenderFns } from "./TextUser.vue?vue&type=template&id=1c5b9372"
import script from "./TextUser.vue?vue&type=script&lang=js"
export * from "./TextUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports